import type React from 'react';

interface Props {
  id: string;
  label: string;
  sizes: string[];
  value: string;
  onChange: (size: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function SizeSelect({ id, label, sizes, value, onChange, disabled, placeholder }: Props) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-ink mb-1">
        {label}
      </label>
      <select
        id={id}
        className="min-h-[46px] w-full rounded-xl border border-stone-200 bg-white px-3 py-2 text-base text-ink shadow-sm disabled:opacity-50"
        value={value}
        disabled={disabled || sizes.length === 0}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
      >
        <option value="">{placeholder ?? (sizes.length === 0 ? 'Choose a brand first' : 'Select a size')}</option>
        {sizes.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </div>
  );
}
